/**
 * Each drop's default amount, as a Schedule row. What a list failing
 * mid-day does lives on List groups. A container shows where the amount
 * comes from; the master config editor, which containers keep their own.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Hash } from 'lucide-react';

import { NumberField } from '@/components/ui';
import { cn } from '@/lib/utils';

import { InheritTag } from '../../master/InheritTag';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { MINIMAL_FIELD } from '../controls/field-style';
import { StepRow } from '../controls/StepRow';

export const DropDefaultsRows: FC<{ editor: ContainerEditor }> = ({ editor }) => {
  const { draft, setField } = editor;
  return (
    <>
      <StepRow icon={Hash} label="Amount" hint="SMS per drop. A drop with its own amount keeps it." aside={<InheritTag section="amount" masterValue={(m) => `${m.defaultAmount.toLocaleString('en-US')} SMS`} />}>
        <div className="flex flex-wrap items-center gap-3">
          <NumberField
            value={draft.defaultAmount}
            onChange={(v) => setField('defaultAmount', v)}
            min={1}
            max={50000}
            aria-label="SMS per drop"
            className={cn(MINIMAL_FIELD, 'w-20 px-3')}
          />
          <span className="text-[13px] text-muted-foreground">SMS per drop, unless a drop sets its own</span>
        </div>
      </StepRow>
    </>
  );
};
